import React from "react";
import { CommonInput } from "../common";
import { StyleSheet, View } from "../platformComponents";
import { colors, fontFamily, fontSize, padding } from "../styles/common";
import { AsFormItemLayout } from "./AsFormItemLayout";
import { i18nCrossUtil, IS_WEB } from "@adgm/libs";
import { KycLabelElement } from "./KycLabelElement";
import type { IFormItemLayout } from "@adgm/cross-models";
import { useGenericFormContext } from "./GenericForm";

type IInputProps = React.ComponentProps<typeof CommonInput>;

type IProps = IInputProps & IFormItemLayout<string>;

export const AsInput: React.FC<IProps> = React.memo(
  ({
    value,
    label,
    error,
    onValueChange,
    tip,
    style,
    hideErrorSpace,
    trim,
    sequenceNumber,
    horizontalLayout,
    required,
    ...otherProps
  }) => {
    const { genericFormType } = useGenericFormContext();
    const isQuestionnaireForm = genericFormType === "questionnaire";
    const handleValueChange = (newValue: string) => {
      if (onValueChange) {
        onValueChange(newValue);
      }
    };

    const getStyle = () => {
      let paddingLeft;
      if (isQuestionnaireForm) {
        paddingLeft = padding.p40;
      } else {
        paddingLeft = 0;
      }

      return {
        flex: 1,
        paddingLeft,
      };
    };

    return (
      <AsFormItemLayout
        horizontalLayout={horizontalLayout}
        label={label}
        error={error}
        tip={tip}
        hideErrorSpace={hideErrorSpace}
        required={required}
        labelElement={
          <KycLabelElement
            label={label}
            sequenceNumber={sequenceNumber}
            horizontalLayout={horizontalLayout}
            required={required}
          />
        }>
        <View style={getStyle()}>
          <CommonInput
            style={[styles.input, style]}
            value={`${value}`}
            onValueChange={handleValueChange}
            placeholderTextColor={IS_WEB ? colors.white21 : colors.white14}
            placeholder={i18nCrossUtil.t()["kyc.please.input"]}
            trim={Boolean(trim)}
            {...otherProps}
          />
        </View>
      </AsFormItemLayout>
    );
  },
);

const styles = StyleSheet.create({
  input: {
    fontSize: fontSize.f14,
    flex: 1,
    fontFamily: IS_WEB ? "Common-Regular" : fontFamily.commonRegular,
    paddingVertical: IS_WEB ? padding.p14 : padding.p16,
    paddingHorizontal: IS_WEB ? padding.p14 : padding.p16,
    borderWidth: IS_WEB ? 0 : 1,
    borderColor: colors.textInputBorderColor,
    backgroundColor: IS_WEB ? colors.grey22 : undefined,
    minWidth: "50%",
  },
});
